module.exports = __webpack_public_path__ + "static/img/icon-pack-up.8cc851ca.svg";